import React, { useState, useEffect } from "react";
import './scrutinizerMapping.css'

import { GET_ALL_BLOCKLIST_AND_REVENUECIRCLE, GET_ADDRESS_BY_PINCODE, authKey, GET_ALL_SCRUTINIZER_LEAD_MAPPING, GET_USER_BY_ROLES, MAP_SCRUTINIZER_TO_LEAD, GET_ALL_STAKEHOLDERS, MAP_STAKEHOLDER_TO_SCRUTINIZER, GET_SCRUTINIZER_STAKEHOLDER_MAPPING, SEARCH_STAKEHOLDER_FOR_SCRUTINY, GET_All_STATE, GET_All_DISTRICT, GET_ALL_UNASSIGNED_SCRUTINIZERS, GET_ALL_SCRUTINIZER_SUPERVISOR_MAPPING, GET_ALL_UNASSIGNED_SCRUTINIZERS_TO_SUPERVISOR, MAP_SCRUTINIZER_TO_SUPERVISOR, SAVE_USER_DISTRICT_MAPPING, GET_USER_DISTRICT_MAPPING, GET_MAPPING_DETAILS_PAGINATED } from '../../../common/URLs';
import { useNavigate, useLocation } from "react-router-dom";
import { Delete as DeleteIcon, Add as AddIcon } from '@mui/icons-material';
import { loaderService } from '../../../common/custom-loader/loader-service';
import { BLOCK_LIST, REVENUE_CIRCLE, REVENUE_BLOCK_DEFAULT_VALUE, Stakeholder_Type_Mapping, ROLES } from '../../../common/constants';
import { Row, Col } from 'react-bootstrap';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import { getLocalStorageItem } from "../../../common/localStorageUtils";
import { PROD } from "../../../common/constants";
import { DataGrid } from '@mui/x-data-grid';
import { QuickSearchToolbar } from "../../../payment/common/commonFunctions";
import { Container, Card, Link, CardContent, IconButton, Button, Tab, Box, Typography, Grid, FormControl, FormControlLabel, FormGroup, InputLabel, Select, MenuItem, TextField, Tooltip, FormHelperText, Autocomplete, Dialog, DialogTitle, DialogContent, DialogActions } from '@mui/material';
import { toast } from 'react-toastify';
import { ConfirmationPopover } from "../../../common/commonPopovers/confirmationPopover";
import { useTranslation } from "react-i18next";
import { lastFiveDigitsComparator } from "../../../common/commonFunction";
import { CloseIcon, EditIcon, SaveIcon, SearchIcon, UpdateIcon } from "../../../common/icons";
import apiClient from "../../../axios";
import CustomDataGridToolbarServer from '../../../common/customDataGridToolbarServer';

const ScrutinizerMapping = (props) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const [saveArray, setSaveArray] = useState([]);
  const [updateArray, setUpdateArray] = useState([]);
  const [deleteArray, setDeleteArray] = useState([]);

  const [editingDistRow, seteditingDistRow] = useState(null);
  const [districtOptions, setDistrictOptions] = useState([]);
  const [selectedDistrictsForUpdate, setSelectedDistrictsForUpdate] = useState([]);
  const [dialogOpen, setDialogOpen] = useState(false);

  const [leadScrutinizerForStakeholder, setLeadScrutinizerForStakeholder] = useState('');
  const [leadScrutinizerForStakeholderID, setLeadScrutinizerForStakeholderID] = useState('');

  const [viewDetails, setViewDetails] = useState(true);
  const [verifyDetails, setVerifyDetails] = useState(false);
  const [mappingtrue, setmappingtrue] = useState(false);
  const [mappingscrutrue, setmappingscrutrue] = useState(false);
  const [mappingsupervisor, setmappingsupervisor] = useState(false);
  // const [mappingScruDst, setMappingScruDst] = useState(false);
  const [leadScrutinizerSelected, setLeadScrutinizerSelected] = useState();
  const [scrutinizerSelected, setScrutinizerSelected] = useState();
  const [leadScrutinizerSelectedID, setLeadScrutinizerSelectedID] = useState();
  const [scrutinizerSelectedID, setScrutinizerSelectedID] = useState();
  const [successResponse, setSuccessResponse] = useState();
  const [pincodeAddressDetails, setPincodeAddressDetails] = useState();
  const [personalRevenueCircleBlocklistLabel, setPersonalRevenueCircleBlocklistLabel] = useState(REVENUE_BLOCK_DEFAULT_VALUE);
  const [personalRevenueCircleAndBlockList, setPersonalRevenueCircleAndBlockList] = useState([]);
  const [leadScrutinizerList, setLeadScrutinizerList] = useState([]);
  const [leadScrutinizerForDstMapping, setLeadScrutinizerForDstMapping] = useState('');
  const [leadScrutinizerForDstMappingID, setLeadScrutinizerForDstMappingID] = useState('');
  const [scrutinizerList, setScrutinizerList] = useState([]);
  const [allScrutinizerMapping, setAllScrutinizerMapping] = useState([]);
/*  const [allScrutinizerMappingTwo, setAllScrutinizerMappingTwo] = useState([]);*/
  const [mapScrutinizerApiData, setMapScrutinizerApiData] = useState([]);
  const [mapped, setMapped] = useState(false);
  const [mappedscru, setMappedscru] = useState(false);
  const [stakeholderSelected, setStakeholderSelected] = useState();
  const [stakeholderSelectedID, setStakeholderSelectedID] = useState();
  const [stakeholderScrutinizerSelectedID, setStakeholderScrutinizerSelectedID] = useState('');
  const [stakeholderScrutinizerSelected, setStakeholderScrutinizerSelected] = useState('');
  const [stakeholderList, setStakeholderList] = useState([]);
  const [selectAll, setSelectAll] = useState(false);
  const [itemChecked, setItemChecked] = useState([]);
  const [selectAllScru, setSelectAllScru] = useState(false);
  const [itemCheckedScru, setItemCheckedScru] = useState([]);
  const [allStakeholderScrutinizerMapping, setAllStakeholderScrutinizerMapping] = useState([]);
  const [mapStakeholderScrutinizerApiData, setStakeholderMapScrutinizerApiData] = useState([]);
  const [mapSupervisorScrutinizerApiData, setMapSupervisorScrutinizerApiData] = useState([]);
  const [leadScrutinizerToBeDeleted, setLeadScrutinizerToBeDeleted] = useState([]);
  /*const [unassignedScrutinizers, setAllUnassignedScrutinizers] = useState([]);*/
  const [allmappedSupervisor, setAllmappedSupervisor] = useState([]);
  const [allUnmappedScrutitoSupervisor, setAllUnmappedScrutitoSupervisor] = useState([]);
  const [mappedLeadScruDist, setMappedLeadScruDist] = useState([]);
  const [editedDistList, setEditedDistList] = useState(mappedLeadScruDist?.length > 0 ? mappedLeadScruDist : []);
  const [active, setActive] = useState(true);
  const [state, setStates] = useState([]);
  const [selectedState, setSelectedState] = useState('');
  const [district, setDistrict] = useState([]);
  const [districtmaster, setDistrictmaster] = useState([]);
  const [selectedDistrict, setSelectedDistrict] = useState([]);
  const [revenueCircle, setRevenueCircle] = useState([]);
  const [logModalOpen, setLogModalOpen] = useState(false);
  const handleLogModalOpen = () => setLogModalOpen(true);
  const handleConfirmLogModalClose = () => setLogModalOpen(false);
  const [logModalOpen3, setLogModalOpen3] = useState(false);
  const handleLogModalOpen3 = () => setLogModalOpen3(true);
  const [logModalOpen4, setLogModalOpen4] = useState(false);
  const handleLogModalOpen4 = () => setLogModalOpen4(true);
  const handleConfirmLogModalClose3 = () => setLogModalOpen3(false);
  const handleConfirmLogModalClose4 = () => setLogModalOpen4(false);
  const [logModalOpenUpdate, setLogModalOpenUpdate] = useState(false);
  const handleLogModalOpenUpdate = () => setLogModalOpenUpdate(true);
  const handleLogModalCloseUpdate = () => setLogModalOpenUpdate(false);
  const [selectedStake, setSelectedStake] = useState();
  const [selectedScru, setSelectedScru] = useState();
  const [selectedRows, setSelectedRows] = useState();
  const [selectedRowsScrutiToSupervisor, setSelectedRowsScrutiToSupervisor] = useState();
  const [selectedStakeholders, setSelectedStakeholders] = useState([]);
  const [supervisorList, setSupervisorList] = useState([]);
  const [supervisorSelectedID, setSupervisorSelectedID] = useState();
  const [selectedSupervisor, setSelectedSupervisor] = useState();
  const [supervisorScrutinizerToBeDeleted, setSupervisorScrutinizerToBeDeleted] = useState([]);
  const [mappingState, setMappingState] = useState('');
  const [leadScrutinizerEmail, setLeadScrutinizerEmail] = useState('');
  const [leadScrutinizerEdited, setLeadScrutinizerEdited] = useState("")

  const [logModalOpenConfirm, setLogModalOpenConfirm] = useState(false);
  const handleLogModalConfirmOpen = () => setLogModalOpenConfirm(true);
  const handleLogModalConfirmClose = () => setLogModalOpenConfirm(false);

  const [logModalOpenStakeholder, setLogModalOpenStakeholder] = useState(false);
  const handleLogModalStakeholderOpen = () => setLogModalOpenStakeholder(true);
  const handleLogModalStakeholderClose = () => setLogModalOpenStakeholder(false);

  const [logModalOpenSupervisor, setLogModalOpenSupervisor] = useState(false);
  const handleLogModalSupervisorOpen = () => setLogModalOpenSupervisor(true);
  const handleLogModalSupervisorClose = () => setLogModalOpenSupervisor(false);

  const [logModalOpenLeadScruDstSave, setLogModalOpenLeadScruDst] = useState(false);
  const handleLogModalOpenLeadScruDst = () => setLogModalOpenLeadScruDst(true);
  const handleLogModalCloseLeadScruDst = () => setLogModalOpenLeadScruDst(false);

  const [logModalOpenLeadScruDstUpdate, setLogModalOpenLeadScruDstUpdate] = useState(false);
  const handleLogModalOpenLeadScruDstUpdate = () => setLogModalOpenLeadScruDstUpdate(true);
  const handleLogModalCloseLeadScruDstUpdate = () => setLogModalOpenLeadScruDstUpdate(false);

  const [logModalOpenLeadScruDstDelete, setLogModalOpenLeadScruDstDelete] = useState(false);
  const handleLogModalOpenLeadScruDstDelete = () => setLogModalOpenLeadScruDstDelete(true);
  const handleLogModalCloseLeadScruDstDelete = () => setLogModalOpenLeadScruDstDelete(false);
    const [page, setPage] = React.useState(0);
    const [pageSize, setPageSize] = React.useState(10);
    const [sortField, setSortField] = React.useState(null);
    const [sortOrder, setSortOrder] = React.useState(null);
    const [searchText, setSearchText] = React.useState("");
    const [rowCount, setRowCount] = React.useState(0);
  const [details, setDetails] = useState({

    selectedPersonalRevenueCircle: '',
    selectedPersonalBlockList: '',

  });

  const [searchFilter, setSearchFilter] = useState({
    stakeHolderType: 'HIT',
    state: '',
    district: '',
    revenueCircleName: '',
    blockName: ''
  });
  const [errorMessage, setErrorMessage] = useState({
    commentsError: "",
    addcommentsError: "",
    revenueError: "",
      supervisorError: "",
      stateError: "",
      leadScrutinizerError: "",
      districtError:""
  })

  const [tabValue, setTabValue] = React.useState('1');

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

    const handleStateChange = (e) => {
    var state = e.target.value;
    setSelectedState(state);
        getAllDistrict(state);
        setSelectedDistrict([]);
    if (state != null && state != '') {
        setErrorMessage({ ...errorMessage, stateError:"" });
    }
  }

  const handleChange = (e) => {
    setDetails({ ...details, [e.target.name]: e.target.value })
    setSearchFilter({ ...searchFilter, [e.target.name]: e.target.value })

    if (e.target.name === "stakeHolderType") {
      setSearchFilter({ ...searchFilter, [e.target.name]: e.target.value })
    }
    if (e.target.name === "state") {
      setSearchFilter({ ...searchFilter, [e.target.name]: e.target.value })
      getAllDistrict(e.target.value);
    }
    if (e.target.name === "district") {
      setSearchFilter({ ...searchFilter, [e.target.name]: e.target.value })
    }
    if (e.target.name === "revenueCircleName") {
      setSearchFilter({ ...searchFilter, [e.target.name]: e.target.value })
    }
  }
    useEffect(() => {
    getListOfUsers(ROLES.LeadRegScrutinizer);
    getListOfUsers(ROLES.RegistrationScruitnizer);
    getStakeholderScrutinizerMapping(page, pageSize, searchText, false, sortField, sortOrder);
    getallmappedScrutinizerToSupervisor();
    getallUnassignedScrutiToSupervisor();
    getListOfSupervisor();
    getMappedScrutinizerDistrictList();
  }, []);

  useEffect(() => {
    if (successResponse) {
      if (successResponse.isSuccess === true) {
          toast.success(successResponse?.message);
          getallmappedScrutinizerToSupervisor();
          getallUnassignedScrutiToSupervisor();
          getStakeholderScrutinizerMapping(page, pageSize, searchText, false, sortField, sortOrder);
          setSelectedStakeholders([]);
          setStakeholderScrutinizerSelected('')
          setStakeholderScrutinizerSelectedID('')
      } else {
        toast.error(successResponse?.message);
      }
    }
  }, [successResponse]);


  const [selectedRow, setSelectedRow] = useState();
  const [selectedRowId, setSelectedRowId] = useState("");
  const onEditMapping = (selectedRow) => {
    setSelectedRowId(selectedRow.scrutinizerID);
    setLeadScrutinizerEdited(selectedRow.leadScrutinizerID);
  }

  const onCancelMapping = () => {
    setSelectedRowId("");

  }

  const onUpdate = (selectedRowData) => {
    setSelectedRow(selectedRowData);
    handleLogModalOpenUpdate();
  }

  //const onConfirmMappingUpdate = () => {
  //  handleLogModalCloseUpdate();
  //  const dataForApi = [{
  //    leadScrutinizerId: leadScrutinizerEdited,
  //    scrutinizerId: selectedRow.scrutinizerID,
  //    isActive: 2
  //  }]
  //  mapScrutinizerToLead(dataForApi);
  //  setSelectedRowId("");
  //}

  const onEditLeadScrutinizer = (e) => {
    setLeadScrutinizerEdited(e.target.value);
  }

  const confirmDeleteStake = (selectedStake) => {
    setSelectedStake(selectedStake);
    handleLogModalOpen();
  }
  const confirmDeleteScru = (selectedScru) => {
    setSelectedScru(selectedScru);
    handleLogModalOpen3();
  }
  const confirmDeleteSupervisor = (selectedSupervisor) => {
    setSelectedSupervisor(selectedSupervisor);
    handleLogModalOpen4();
  }

  useEffect(() => {
    if (editingDistRow) {
      const state = editingDistRow?.state?.toUpperCase();
      if (districtmaster[state]) {
        setDistrictOptions(districtmaster[state]);
      }
    }
  }, [editingDistRow, districtmaster]);


  const getMappedScrutinizerDistrictList = () => {
    loaderService.showLoader()
    apiClient
      .post(GET_USER_DISTRICT_MAPPING,
        {

        },
        {
          headers: {
            Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
          },
        }
      )
      .then((response) => {
        const transformedData = response.data.userDistrictMappings?.flatMap(user => {
          const stateGroups = {};
          user.districts.forEach(({ state, district }) => {
              if (!stateGroups[state])
                  stateGroups[state] = [];
            stateGroups[state].push(district);
          });

          return Object.entries(stateGroups).map(([state, districts]) => ({
            id: user.id+'_'+state,
           // id: user.id,
            userId: user.userId,
            userName: user.userName,
            isActive: user.isActive,
            state,
            districts
          }));
        });
        setMappedLeadScruDist(transformedData);
        loaderService.hideLoader()
      })
      .catch(function (error) {
        console.log(error);
        loaderService.hideLoader()

      });
  }

  useEffect(() => {
    getAllStates();
  }, []);
  const getAllStates = () => {
    loaderService.showLoader()
    apiClient
      .post(GET_All_STATE,
        {

        },
        {
          headers: {
            AuthKey: authKey,
          },
        }
      )
      .then((response) => {
        setStates(response.data.stateList);
        loaderService.hideLoader()
      })
      .catch(function (error) {
        console.log(error);
        loaderService.hideLoader()

      });
  }


  const getAllDistrict = (state) => {
    loaderService.showLoader()
    apiClient
      .post(GET_All_DISTRICT,
        {
          "state": state ? state : ""
        },
        {
          headers: {
            AuthKey: authKey,
          },
        }
      )
      .then((response) => {
        setDistrict(response.data.districtLists);
        setDistrictmaster(prev => ({
          ...prev, [state?.toUpperCase()]: response.data.districtLists
        }))
        loaderService.hideLoader()
      })
      .catch(function (error) {
        console.log(error);
        loaderService.hideLoader()

      });
  }
  useEffect(() => {
    if (searchFilter.district) {
      getAllRevnueCircleList();
    }
  }, [searchFilter.district]);

  const getAllRevnueCircleList = () => {
    loaderService.showLoader()

    apiClient
      .post(GET_ALL_BLOCKLIST_AND_REVENUECIRCLE,
        {
          "district": searchFilter.district
        },
        {
          headers: {
            AuthKey: authKey,
          },
        }
      )
      .then((response) => {
        if (searchFilter.state === "ASSAM") {
          setPersonalRevenueCircleBlocklistLabel(REVENUE_CIRCLE)
          setRevenueCircle(response.data.revenueCircleAndBlockList.revenueCircleLists)
          //setSearchFilter({ ...searchFilter, revenueCircleName: response.data.revenueCircleAndBlockList.revenueCircleLists?.[0] })
        } else {
          setPersonalRevenueCircleBlocklistLabel(BLOCK_LIST)
          setRevenueCircle(response.data.revenueCircleAndBlockList.blockLists)
          // setSearchFilter({ ...searchFilter, revenueCircleName: response.data.revenueCircleAndBlockList.blockLists?.[0] })
        }
        loaderService.hideLoader()
      })
      .catch(function (error) {
        console.log(error);
        loaderService.hideLoader()

      });
  }
  useEffect(() => {
    if (pincodeAddressDetails) {
      loaderService.showLoader();
      apiClient.post(GET_ALL_BLOCKLIST_AND_REVENUECIRCLE,
        {
          "district": pincodeAddressDetails?.addresses[0]?.district,
        },
        {
          headers: {
            AuthKey: authKey,
          },
        }
      )
        .then((response) => {
          if (pincodeAddressDetails?.addresses[0]?.state === "ASSAM") {
            setPersonalRevenueCircleBlocklistLabel(REVENUE_CIRCLE)
            setPersonalRevenueCircleAndBlockList(response.data.revenueCircleAndBlockList.revenueCircleLists)
            if (response.data.revenueCircleAndBlockList.revenueCircleLists.length > 0) {
              setDetails({ ...details, selectedPersonalRevenueCircle: response.data.revenueCircleAndBlockList.revenueCircleLists[0], selectedPersonalBlockList: "" })
            } else setDetails({ ...details, selectedPersonalRevenueCircle: '' })
          } else {
            setPersonalRevenueCircleBlocklistLabel(BLOCK_LIST)
            setPersonalRevenueCircleAndBlockList(response.data.revenueCircleAndBlockList.blockLists)
            if (response.data.revenueCircleAndBlockList.blockLists.length > 0) {
              setDetails({ ...details, selectedPersonalBlockList: response.data.revenueCircleAndBlockList.blockLists[0], selectedPersonalRevenueCircle: "" })
            } else setDetails({ ...details, selectedPersonalBlockList: '' })

          }
          loaderService.hideLoader();
        })
        .catch(function (error) {
          console.log(error);
          loaderService.hideLoader();
        });

    }
  }, [pincodeAddressDetails]);
  const getListOfUsers = (userRole) => {
    loaderService.showLoader()
    apiClient
      .post(GET_USER_BY_ROLES,
        {
          "roleName": userRole,
          "district": ""
        },
        {
          headers: {
            Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
          }
        }, null
      )
      .then((response) => {
          loaderService.hideLoader();
          var users = response.data.users;
          const sorted = [...users].sort((a, b) => (a.firstname + ' ' + a.middlename + ' ' + a.lastname).localeCompare(b.firstname + ' ' + b.middlename + ' ' + b.lastname));
          if (userRole == ROLES.LeadRegScrutinizer) {
              setLeadScrutinizerList(sorted);
          }
          else if (userRole == ROLES.RegistrationScruitnizer) {
              setScrutinizerList(sorted);
          }
      })
      .catch(function (error) {
        loaderService.hideLoader()
        console.log(error);
      });
  }
  const getListOfSupervisor = () => {
    loaderService.showLoader()
    apiClient
      .post(GET_USER_BY_ROLES,
        {
          "roleName": ROLES.RegSuperVisor,
          "district": ""
        },
        {
          headers: {
            Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
          }
        }, null
      )
      .then((response) => {
        loaderService.hideLoader()
        setSupervisorList(response.data.users)
      })
      .catch(function (error) {
        loaderService.hideLoader()
        console.log(error);
      });
  }
  const mapScrutinizerToSupervisor = (dataForApi) => {
    loaderService.showLoader();
    apiClient
      .post(MAP_SCRUTINIZER_TO_SUPERVISOR,
        {
          "supervisorMappings": dataForApi,
          "isSuccess": true,
          "message": "string"
        },
        {
          headers: {
            Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
          }
        }
      )
      .then((response) => {
        setSuccessResponse(response.data)

        loaderService.hideLoader();
      })
      .catch(function (error) {
        console.log(error);
        loaderService.hideLoader();
      });
  }

  const getListOfStakeholder = () => {
    // if (searchFilter.stakeHolderType === "Grower" ? searchFilter.revenueCircleName : true) {
    //   setErrorMessage({ ...errorMessage, revenueError: " " });

    loaderService.showLoader();
    apiClient
      .post(SEARCH_STAKEHOLDER_FOR_SCRUTINY,

        {
          "pinCode": "string",
          "revenueCircle": searchFilter?.revenueCircleName ? searchFilter?.revenueCircleName : '',
          "stakeholderType": searchFilter?.stakeHolderType,
          "state": searchFilter?.state,
          "district": searchFilter?.district ? searchFilter?.district : '',

          // "revenueCircle": personalRevenueCircleBlocklistLabel === REVENUE_CIRCLE ? details.selectedPersonalRevenueCircle : details.selectedPersonalBlockList
        },
        {
          headers: {
            Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
          }
        }, null
      )
      .then((response) => {
        setStakeholderList(response.data.stakeHolders)
        setMapped(true);
        setStakeholderSelected([]);
        setStakeholderSelectedID([]);
        setItemChecked([]);
        loaderService.hideLoader();
      })
      .catch(function (error) {
        console.log(error);
        loaderService.hideLoader();
      });
  }

  const mapStakeholderToScrutinizer = (dataForApi) => {
    loaderService.showLoader();
    apiClient
      .post(MAP_STAKEHOLDER_TO_SCRUTINIZER,
        {
          "stakeholderMappings": dataForApi
        },
        {
          headers: {
            Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
          }
        }
      )
      .then((response) => {
        setSuccessResponse(response.data);
        getStakeholderScrutinizerMapping(page, pageSize, searchText, false, sortField, sortOrder);
        setSelectedStakeholders([]);
        setStakeholderScrutinizerSelected('');
        setStakeholderScrutinizerSelectedID('');
        loaderService.hideLoader();
      })
      .catch(function (error) {
        console.log(error);
        loaderService.hideLoader();
      });
    }
    const handleSortModelChange = async (model) => {
        setSortField(model[0]?.field);
        setSortOrder(model[0]?.sort);
        await getStakeholderScrutinizerMapping(page, pageSize, searchText, false, model[0]?.field, model[0]?.sort);
    }
    const fetchSearchData = async (searchInput) => {
        setSearchText(searchInput);
        await getStakeholderScrutinizerMapping(page, pageSize, searchInput, false, sortField, sortOrder);
    };
    const fetchData = async () => {
        return await getStakeholderScrutinizerMapping(0, 0, searchText, true, sortField, sortOrder);
    }
    const getStakeholderScrutinizerMapping = async (pageNo = 0, pageSize = 10, searchText = "", isExport = false, sortColumn = "LastUpdatedDate", sortDirection = "desc") => {
    loaderService.showLoader();
        let response =await apiClient
            .post(GET_MAPPING_DETAILS_PAGINATED,
                {
                    "userID": getLocalStorageItem('uuid'),
                    "userRole": getLocalStorageItem('role'),
                    "pageNumber": pageNo,
                    "pageSize": pageSize,
                    "sortColumn": sortColumn ? sortColumn : "LastUpdatedDate",
                    "sortDirection": sortDirection ? sortDirection : "desc",
                    "filterText": searchText
                },
                {
                    headers: {
                        Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
                    }
                }
        );
        loaderService.hideLoader();
        if (isExport) {
            return response?.data?.scrutinizermappings;
        }
        else {
            setAllStakeholderScrutinizerMapping(response.data?.scrutinizermappings);
            setRowCount(response.data?.totalCount);
        }

  }
  const getallmappedScrutinizerToSupervisor = () => {
    loaderService.showLoader();
    apiClient
      .post(GET_ALL_SCRUTINIZER_SUPERVISOR_MAPPING,
        {

        },
        {
          headers: {
            Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
          }
        }
      )
      .then((response) => {
        setAllmappedSupervisor(response.data.supervisorMappings)
        loaderService.hideLoader();
      })
      .catch(function (error) {
        console.log(error);
        loaderService.hideLoader();
      });
  }
  const getallUnassignedScrutiToSupervisor = () => {
    loaderService.showLoader();
    apiClient
      .post(GET_ALL_UNASSIGNED_SCRUTINIZERS_TO_SUPERVISOR,
        {

        },
        {
          headers: {
            Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
          }
        }
      )
      .then((response) => {
        setAllUnmappedScrutitoSupervisor(response.data.users)
        loaderService.hideLoader();
      })
      .catch(function (error) {
        console.log(error);
        loaderService.hideLoader();
      });
  }
  const onChangeSupervisor = (e) => {
    let selectedScrutinizerToSupervisor = supervisorList.filter((item) => item.id === e.target.value)
    // setLeadScrutinizerSelected(selectedScrutinizer[0].firstname)
    setSupervisorSelectedID(selectedScrutinizerToSupervisor[0].id)
  }
  const onChangeStakeholderScrutinizer = (e) => {
    let selectedScrutinizer = scrutinizerList.filter((item) => item.id === e.target.value)
    setStakeholderScrutinizerSelected(selectedScrutinizer[0].firstname)
    setStakeholderScrutinizerSelectedID(selectedScrutinizer[0].id)
  }

  const handleLeadScrutinizerForStakeholder = (e) => {
    let selectedLeadScrutinizer = leadScrutinizerList?.filter((item) => item.id === e.target.value)
    setLeadScrutinizerForStakeholder(selectedLeadScrutinizer[0].firstname)
    setLeadScrutinizerForStakeholderID(selectedLeadScrutinizer[0].id)
  }

  const onStakeholderScrutinizerAdd = () => {
    handleLogModalStakeholderClose();
    if (stakeholderScrutinizerSelected && selectedStakeholders.length > 0) {
      setErrorMessage({ ...errorMessage, addcommentsError: " " });
      // let apiArr = [...mapStakeholderScrutinizerApiData]
      // const arr = [...selectedStakeholders, ...apiArr]
      const apiObjData = selectedStakeholders.map((item) => (
        {
          scrutinizerId: stakeholderScrutinizerSelectedID,
          leadScrutinizerID: leadScrutinizerForStakeholderID,
          stakeholderID: item,
          loggedInUserID: props.userID,
          isActive: mappingState === "Add" ? 1 : 2
        }))
      setStakeholderMapScrutinizerApiData(apiObjData)
      setMapped(false);
      setmappingtrue(false);
      mapStakeholderToScrutinizer(apiObjData);
    } else {
      //setErrorMessage({ ...errorMessage, addcommentsError: "Select atleast one Stakeholder, Scrutinizer and Lead Scrutinizer" });
      toast.error("Please select Stakeholders, Scrutinizer and Lead Scrutinizer.")
    }
  }

  const onScrutinizerSupervisorAdd = () => {
    handleLogModalSupervisorClose();
    if (supervisorSelectedID && selectedRowsScrutiToSupervisor) {
      setErrorMessage({ ...errorMessage, supervisorError: "" });

      let tempArr = [...allmappedSupervisor]
      let apiArr = [...mapSupervisorScrutinizerApiData]
      const arr = [...selectedRowsScrutiToSupervisor, ...apiArr]
      const apiObjData = arr.map((item) => (
        {
          supervisorId: supervisorSelectedID,
          scrutinizerId: item,
          isActive: 1
        }))
      const objCreated = {
        supervisorId: supervisorSelectedID,
        scrutinizerId: selectedRowsScrutiToSupervisor,

      }
      setMapScrutinizerApiData(apiObjData)
      setMapSupervisorScrutinizerApiData(apiObjData)
      setmappingscrutrue(false);
      mapScrutinizerToSupervisor(apiObjData);

    } else {
      setErrorMessage({ ...errorMessage, supervisorError: "Select one Supervisor and Scrutinizer" });
    }
  }
  const onStakeholderScrutinizerRemove = () => {
    handleConfirmLogModalClose();
    const tempdata = allStakeholderScrutinizerMapping.filter((item) => !(item.scrutinizerID === selectedStake.scrutinizerID
      && item.urn === selectedStake.urn));
    const deleteData = allStakeholderScrutinizerMapping.filter((item) => item.scrutinizerID === selectedStake.scrutinizerID
      && item.urn === selectedStake.urn);
    console.log("deleteData", deleteData)
    setAllStakeholderScrutinizerMapping(tempdata)
    const dataForApi = deleteData?.map((item) => (
      {
        scrutinizerId: item.scrutinizerID,
        leadScrutinizerID: item.leadScrutinizerID,
        stakeholderID: item.stakeHolderMasterID,
        loggedInUserID: props.userID,
        isActive: 0
      }))

    setStakeholderMapScrutinizerApiData(dataForApi)
    mapStakeholderToScrutinizer(dataForApi);
  }
  const onSupervisorScrutinizerRemove = () => {
    handleConfirmLogModalClose4();
    const tempdata = allmappedSupervisor.filter((item) => !(item?.scrutinizerID === selectedSupervisor.scrutinizerID
      && item?.supervisorID === selectedSupervisor.supervisorID))

    const deleteData = allmappedSupervisor.filter((item) => item.scrutinizerID === selectedSupervisor.scrutinizerID
      && item.supervisorID === selectedSupervisor.supervisorID)
    setAllmappedSupervisor(tempdata)
    setSupervisorScrutinizerToBeDeleted(deleteData)
    const arr = [...supervisorScrutinizerToBeDeleted, ...deleteData]
    const dataForApi = arr.map((item) => (
      {
        scrutinizerId: item.scrutinizerID,
        supervisorId: item.supervisorID,
        isActive: 0
      }))

    setMapSupervisorScrutinizerApiData(dataForApi)
    mapScrutinizerToSupervisor(dataForApi);
  }
  const addnewBtnClick = (e) => {
    setmappingtrue(true);
    setMapped(false);
    setStakeholderMapScrutinizerApiData([]);
    setStakeholderSelected([]);
    setStakeholderSelectedID([]);
    setItemChecked([]);
    setErrorMessage({ ...errorMessage, addcommentsError: "" });
  }
  function goCancel(e) {
    setmappingtrue(false);
    setSelectedStakeholders([]);
    setErrorMessage({ ...errorMessage, addcommentsError: "" });
  }
  const addnewBtnClickSupervisor = (e) => {
    getallmappedScrutinizerToSupervisor();
    setmappingsupervisor(true);
    getallUnassignedScrutiToSupervisor();
    setMapSupervisorScrutinizerApiData([]);

  }
  function goCancelSupervisor(e) {
    setmappingsupervisor(false);
    // setMapped(true);

  }

  const onConfirmMappingLeadScruDstSave = (e) => {
    handleLogModalCloseLeadScruDst();
    saveUserDistricMapping(saveArray)
  }
    const onCancel = (e) => {
        setSelectedState('');
        setSelectedDistrict([]);
        setLeadScrutinizerForDstMappingID('');
        setLeadScrutinizerEmail('');
        setDistrict([]);
        setDistrictmaster([]);
        setErrorMessage({ ...errorMessage, leadScrutinizerError: "", stateError: "", districtError:"" });

    }
    const onSave = () => {
        if (leadScrutinizerForDstMappingID == null || leadScrutinizerForDstMappingID == '') {
            setErrorMessage({ ...errorMessage, leadScrutinizerError: "Please select lead scrutinizer" });
            //toast.error("Please select lead scrutinizer");
            return false;
        }
        if (selectedState == null || selectedState == '') {
            setErrorMessage({ ...errorMessage, stateError: "Please select state" });
            //toast.error("Please select state");
            return false;
        }
        if (selectedDistrict == null || selectedDistrict.length == 0) {
            setErrorMessage({ ...errorMessage, districtError: "Please select district" });
            return false;
        }
    setSaveArray({
      userId: leadScrutinizerForDstMappingID,
      isActive: 1,
      lstDistrict: selectedDistrict?.map(d => ({ state: selectedState, district: d }))
    })
    handleLogModalOpenLeadScruDst();
  }

  const saveUserDistricMapping = (mapping) => {
    apiClient.post(SAVE_USER_DISTRICT_MAPPING, mapping,
      {
        headers: {
          Authorization: "Bearer " + getLocalStorageItem('id_token')
        }
      }
    ).then((response) => {
      if (response.data.isSuccess === true) {
        getMappedScrutinizerDistrictList();
        setLeadScrutinizerForDstMapping('');
        setLeadScrutinizerForDstMappingID('');
        setSelectedState('');
        setSelectedDistrict([]);
        setSelectedDistrictsForUpdate([]);
        setLeadScrutinizerEmail('');
        toast.success("Lead scrutinizer district mapping saved successfully.")
      }
      else toast.error(response.data.message)
    }).catch((error) => {
      console.log(error)
      toast.error('Please try again !')
    })
  }
  const mappedLeadScrutiDstCol = [
    {
      field: 'id', headerName: 'S.No.', width: 60,
      renderCell: (index) => index.api.getRowIndex(index.row.id) + 1
    },
    { field: 'userName', headerName: 'Lead Scrutinizer', width: 200 },
    { field: 'state', headerName: 'State', width: 200 },
    {
      field: 'districts',
      headerName: 'Districts',
      width: 300,
      renderCell: (params) => (
        <div style={{ whiteSpace: 'pre-line' }}>
          {params.row.districts.join(',\n')}
        </div>
      )
    },
    {
      field: 'action', headerName: 'Actions', width: 220,
      renderCell: (params) => {
        return (
          <>
            {/* {params.row.id === editingRowIdDist ?
              <Box display='flex' alignItems="center" justifyContent="center">
                <Button size="small" variant="contained" onClick={() => onUpdate(params?.row)}>{t('reg.update')}</Button>
                <Button size="small" sx={{ ml: 2 }} variant="outlined" onClick={() => onCancelDistMapping(params?.row)}>{t('reg.cancel')}</Button>
              </Box>
              : */}
            <Tooltip title="Edit"><IconButton size="small" color="primary" onClick={(e) => {
              getAllDistrict(params.row.state?.toUpperCase())
              seteditingDistRow(params.row);
              setSelectedDistrictsForUpdate(params.row.districts || []);
              setDialogOpen(true);
            }
            }>
              <EditIcon /></IconButton></Tooltip>
            {/* } */}
            <Tooltip title="Delete">
              <IconButton size="small" color="error" onClick={() => onDeleteLeadScruDist(params?.row)} component="label">
                <DeleteIcon />
              </IconButton>
            </Tooltip>
          </>
        );

      }
    },
  ];
  const mappedStakeholderCol = [
    {
      field: 'id', headerName: 'S.No.', width: 60,
      renderCell: (index) => index.api.getRowIndex(index.row.workflowMasterID) + 1
    },
    { field: 'urn', headerName: 'URN', width: 200, renderCell: (params) => { return (<Link to={params} onClick={() => { onView(params?.row?.urn, params?.row?.stakeholderType, params?.row?.stakeholderSubCategory) }}>{params.value}</Link>) } },
    { field: 'stakeholderType', headerName: 'Stakeholder Type', width: 200 },
    { field: 'status', headerName: 'Status', width: 180 },
    { field: 'lastUpdatedDate', headerName: 'Last Updated Date', width: 180 },
    { field: 'scrutinizerName', headerName: 'Scrutinizer Name', width: 180 },
    { field: 'leadScrutinizerName', headerName: 'Lead Scrutinizer Name', width: 180 },
    {
      field: 'action', headerName: 'Action', width: 60,
      renderCell: (index) => {
        return (
          <Tooltip title="Delete">
            <IconButton color="error" onClick={() => confirmDeleteStake(index?.row)} component="label">
              <DeleteIcon />
            </IconButton>
          </Tooltip>
        );

      }
    },
  ];
  const mappedSupervisorCol = [
    {
      field: 'id', headerName: 'S.No.', width: 60,
      renderCell: (index) => index.api.getRowIndex(index.row.scrutinizerID) + 1
    },
    { field: 'scrutinizerName', headerName: 'Scrutinizer', width: 250 },
    { field: 'supervisorName', headerName: 'Supervisor', width: 250 },
    {
      field: 'action', headerName: 'Action', width: 60,
      renderCell: (index) => {
        return (
          <Tooltip title="Delete">
            <IconButton style={{ color: 'red' }} onClick={() => confirmDeleteSupervisor(index?.row)} component="label">
              <DeleteIcon />
            </IconButton>
          </Tooltip>
        );

      }
    },
  ];
  const unmappedScrutinizerCol = [
    {
      field: 'firstname', headerName: 'Scrutinizer Name', width: 220,
      valueGetter: (params) => {
        if (params) {
          return params.row.firstname + " " + params.row.middlename + " " + params.row.lastname
        } else return '-'
      }
    },
    { field: 'emailAddress', headerName: 'Email Address', width: 200 },
    // { field: 'state', headerName: 'State', width: 200 },
  ];
  const unmappedSupervisorCol = [
    {
      field: 'firstname', headerName: 'Scrutinizer', width: 220,
      valueGetter: (params) => {
        if (params) {
          return params.row.firstname + " " + params.row.middlename + " " + params.row.lastname
        } else return '-'
      }
    },
    { field: 'emailAddress', headerName: 'Email Address', width: 200 },
  ];
  const unmappedStakeholderCol = [
    { field: 'urn', headerName: 'URN', width: 220, sortComparator: (a, b) => lastFiveDigitsComparator(a, b) },
    {
      field: 'name', headerName: t('preReg.name'), width: 180,
      renderCell: (params) => (
        <div style={{ whiteSpace: 'normal', wordWrap: 'break-word', width: '100%' }}>
          {params.row.subCategory && params.row.subCategory.toLowerCase() == "individual" ? (params.row.contactPersonFirstname + (params.row.contactPersonMiddlename ? " " + params.row.contactPersonMiddlename : "") + " " + params.row.contactPersonLastname) : params.row.name}
        </div>
      ),
      valueGetter: (params) => params.row.subCategory && params.row.subCategory.toLowerCase() == "individual" ? (params.row.contactPersonFirstname + (params.row.contactPersonMiddlename ? " " + params.row.contactPersonMiddlename : "") + " " + params.row.contactPersonLastname) : params.row.name
    },
    { field: 'registrationStatus', headerName: 'Resgistration Status', width: 210 },
    { field: 'lastUpdatedDate', headerName: 'Last Updated Date', width: 220 },
  ];

  const confirmSubmission = (e) => {
    handleLogModalConfirmOpen();
  }

  const confirmStakeholderSubmission = (state) => {
    setMappingState(state);
    handleLogModalStakeholderOpen();
  }
  const confirmSupervisorSubmission = (e) => {
    handleLogModalSupervisorOpen();
  }
  const onView = (urnSelected, stakeholderType, growerSubCategory) => {
    const userData = {
      "urnSelected": urnSelected,
      "isScrutinyView": true

    }
    if (stakeholderType === "Transporter") {
      navigate("/registrationHome/dashboard/registrationDetailsTransporter", { state: { data: userData, URN: urnSelected } });
    }
    else if (stakeholderType === "HIT") {
      navigate("/registrationHome/dashboard/registrationDetailsHit", { state: { data: userData, URN: urnSelected } });
    }
    else if (stakeholderType === "LLE") {
      navigate("/registrationHome/dashboard/registrationDetailsLle", { state: { data: userData, URN: urnSelected } });
    }
    else if (stakeholderType === "Interim Storage Operator") {
      navigate("/registrationHome/dashboard/registrationDetailsTempStorage", { state: { data: userData, URN: urnSelected } });
    }
    else if (growerSubCategory == "Individual" || growerSubCategory == "JFMC" || growerSubCategory === "Other Agency") {
      navigate("/registrationHome/dashboard/registrationDetails", { state: { data: userData, URN: urnSelected } });
    }
    else if (growerSubCategory === "Co-operative" || growerSubCategory === "FPO" || growerSubCategory === "SHG" || growerSubCategory === "FPC") {
      navigate("/registrationHome/dashboard/registrationMemberDetails", { state: { data: userData, URN: urnSelected } });
    }
    else if (growerSubCategory === "Forest") {
      navigate("/registrationHome/dashboard/registrationDetailsForest", { state: { data: userData, URN: urnSelected } });
    }
    else {
      // navigate("/registrationHome/dashboard/onView", { state: { data: userData } });
    }
  }

  const handleLeadScrutinizerForDstMapping = (e) => {
    let selectedScrutinizer = leadScrutinizerList?.filter((item) => item.id === e.target.value)
    setLeadScrutinizerForDstMapping(selectedScrutinizer[0].firstname)
    setLeadScrutinizerForDstMappingID(selectedScrutinizer[0].id)
    setLeadScrutinizerEmail(selectedScrutinizer[0].emailAddress);
    if (selectedScrutinizer != null && selectedScrutinizer[0].id != '') {
        setErrorMessage({ ...errorMessage, leadScrutinizerError:''});
    }
  }

  const onAddDistricts = (e, value) => {
      setSelectedDistrict(value);
      if (value != null && value.length > 0) {
          setErrorMessage({ ...errorMessage, districtError: "" });
      }
  }

  const transformRowsToOriginal = (filteredRows, isDelete = false) => {
    const grouped = {};

    filteredRows?.forEach(({ id, userId, userName, isActive, state, districts }) => {
      if (!grouped[userId]) {
        grouped[userId] = {
          id,
          userId,
          userName,
          isActive: isDelete ? 0 : 1,
          lstDistrict: []
        };
      }

      districts?.forEach(district => {
        grouped[userId]?.lstDistrict?.push({ state, district });
      });
    });

    return Object?.values(grouped);
  };


  const onUpdateMappedDistricts = () => {
    if (selectedDistrictsForUpdate?.length === 0) {
      toast.error("At least one district must be selected!")
    }
    else {
      const updatedRows = mappedLeadScruDist?.map(row =>
        row.id === editingDistRow?.id
          ? { ...row, districts: selectedDistrictsForUpdate }
          : row
      );
      setMappedLeadScruDist(updatedRows);
      setDialogOpen(false);

      const editedUserRows = updatedRows?.filter(row => row?.userId === editingDistRow?.userId);
      const payload = transformRowsToOriginal(editedUserRows);

      setUpdateArray(payload[0]);
      handleLogModalOpenLeadScruDstUpdate();
    }
  }

  const onConfirmMappingLeadScruDstUpdate = (e) => {
    handleLogModalCloseLeadScruDstUpdate();
    saveUserDistricMapping(updateArray);
  }

  const onDeleteLeadScruDist = (selectedRow) => {
    const payload = transformRowsToOriginal([selectedRow], true);
    setDeleteArray(payload[0]);
    handleLogModalOpenLeadScruDstDelete();
  }

  const onConfirmMappingLeadScruDstDelete = (e) => {
    handleLogModalCloseLeadScruDstDelete();
    saveUserDistricMapping(deleteArray);
  }

  return (
    <div>
      {!PROD && <p style={{ textAlign: "center", fontSize: "2vh" }}>REG58</p>}
      <Card>
        <CardContent>
          <Container fluid>
            <Row>
              <Col xs={12} md={12} >
                <TabContext value={tabValue}>
                  <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                    <TabList onChange={handleTabChange} aria-label="lab API tabs example">
                      {/*   <Tab label="Scrutinizer Mapping" value="1" />*/}
                      <Tab label="Lead Scrutinizer District Mapping" value="1" />
                      <Tab label="Stakeholder Mapping" value="2" />
                      <Tab label="Supervisor Mapping" value="3" />
                
                    </TabList>
                  </Box>
                                  <TabPanel value="1" style={{ padding: "2vh 0vh 0vh 0vh" }}>
                                      <Grid container spacing={3}>
                                          <Grid item xs={12} lg={4}>
                                              <FormControl fullWidth >
                                                  <InputLabel>Lead Scrutinizer</InputLabel>
                                                  <Select label="Lead Scrutinizer"
                                                      onChange={(e) => handleLeadScrutinizerForDstMapping(e)}
                                                      value={leadScrutinizerForDstMappingID}
                                                      required
                                                      error={errorMessage?.leadScrutinizerError}
                                                      helperText={errorMessage?.leadScrutinizerError}>
                                                      <MenuItem disabled selected value=""> -- select an option -- </MenuItem>
                                                      {leadScrutinizerList?.map((item) => (
                                                          <MenuItem value={item.id}>{item.firstname + ' ' + item.middlename + ' ' + item.lastname}</MenuItem>
                                                      ))}
                                                  </Select>
                                                  <FormHelperText sx={{ color: 'red' }}>{errorMessage?.leadScrutinizerError}</FormHelperText>
                                              </FormControl>
                                              <TextField fullWidth sx={{ marginTop: "3vh" }}
                                                  label="Email Address"
                                                  name="LeadScruEmail"
                                                  value={leadScrutinizerEmail}
                                                  disabled />
                                          </Grid>
                                          <Grid item xs={12} lg={4}>
                                              <FormControl fullWidth>
                                                  <InputLabel>State</InputLabel>
                                                  <Select name='state' label="State" onChange={(e) => handleStateChange(e)}
                                                      value={selectedState}
                                                      required
                                                      error={errorMessage?.stateError}
                                                      helperText={errorMessage?.stateError}>
                                                      <MenuItem disabled selected value=""> -- select an option -- </MenuItem>
                                                      {state?.map((item) => <MenuItem key={item} value={item}>{item}</MenuItem>)}
                                                  </Select>
                                                  <FormHelperText sx={{ color: 'red' }}>{errorMessage?.stateError}</FormHelperText>
                                              </FormControl>
                                          </Grid>
                                          <Grid item xs={12} lg={4}>
                                              <Autocomplete
                                                  multiple
                                                  options={district}
                                                  value={selectedDistrict}
                                                  onChange={(e, value) => onAddDistricts(e, value)}
                                                  required
                                                  error={errorMessage?.districtError}
                                                  renderInput={(params) => (
                                                      <TextField
                                                          {...params}
                                                          // error={errorMessage.areaErr}
                                                          // helperText={errorMessage.areaErr}
                                                          required
                                                          label="District"
                                                      />
                                                  )}
                                              />
                                              <FormHelperText sx={{ color: 'red' }}>{errorMessage?.districtError}</FormHelperText>
                                          </Grid>
                                          <Grid item xs={12} lg={12}>
                                              <Box display='flex' alignItems="center" justifyContent="center" mt={1} style={{ float: "right" }}>
                                                  <Button startIcon={<CloseIcon />} sx={{ minWidth: 100 }} variant="outlined" onClick={(e) => onCancel(e)}>Cancel</Button>
                                                  <Button startIcon={<SaveIcon />} sx={{ minWidth: 100, ml: 1 }} variant="contained" onClick={() => onSave()}>Save</Button>
                                              </Box>
                                          </Grid>
                                          <Grid item xs={12} lg={12}>
                                              <Box sx={{
                                                  height: 500, width: '100%',
                                                  '& .MuiDataGrid-cell--editable': {
                                                      bgcolor: (theme) =>
                                                          theme.palette.mode === 'dark' ? '#376331' : 'rgb(217 243 190)',
                                                  },
                                              }}>

                                                  {
                                                      mappedLeadScruDist &&
                                                      <DataGrid
                                                          getRowHeight={() => 'auto'}
                                                          rows={mappedLeadScruDist}
                                                          columns={mappedLeadScrutiDstCol}
                                                          pageSize={10}
                                                          components={{ Toolbar: QuickSearchToolbar }}
                                                          getRowId={(rows) => rows.id}
                                                      />
                                                  }
                                              </Box>
                                          </Grid>
                                      </Grid>
                                  </TabPanel>
                  <TabPanel value="2" style={{ padding: "2vh 0vh 0vh 0vh" }}>
                    <div>
                      {mappingtrue === true ? <div>
                        <Row className="row_search">
                          <Row>
                            <Col xs={12} md={3}>
                              <FormControl fullWidth>
                                <InputLabel>Stakeholder Type</InputLabel>
                                <Select name='stakeHolderType' label="Stakeholder Type" onChange={(e) => handleChange(e)} value={searchFilter.stakeHolderType} >
                                  <MenuItem disabled selected value=""> -- select an option -- </MenuItem>
                                  {Stakeholder_Type_Mapping.map((item) => (<MenuItem value={item}>{item}</MenuItem>))}
                                </Select>
                              </FormControl>
                            </Col>
                          </Row>
                          {searchFilter.stakeHolderType === "Grower" ? <Row> <Col xs={12} md={3} style={{ marginTop: "1vh" }}>
                            <FormControl fullWidth>
                              <InputLabel>State</InputLabel>
                              <Select name='state' label="State" onChange={(e) => handleChange(e)} value={searchFilter.state}>
                                <MenuItem disabled selected value=""> -- select an option -- </MenuItem>
                                {state?.map((item) => <MenuItem key={item} value={item}>{item}</MenuItem>)}
                              </Select>
                            </FormControl>
                          </Col>
                            <Col xs={12} md={3} style={{ marginTop: "1vh" }}>
                              <FormControl fullWidth>
                                <InputLabel>District</InputLabel>
                                <Select name='district' label="District" onChange={(e) => handleChange(e)} value={searchFilter.district}>
                                  <MenuItem selected value=""> -- select an option -- </MenuItem>
                                  {district?.map((item) => <MenuItem key={item} value={item}>{item}</MenuItem>)}
                                </Select>
                              </FormControl>
                            </Col>
                            <Col xs={12} md={4} style={{ marginTop: "1vh" }}>
                              <FormControl fullWidth>
                                <InputLabel>RevenueCircle/BlockOffice</InputLabel>
                                <Select name='revenueCircleName' label="RevenueCircle/BlockOffice" onChange={(e) => handleChange(e)} value={searchFilter.revenueCircleName}>
                                  <MenuItem selected value=""> -- select an option -- </MenuItem>
                                  {revenueCircle?.map((item) => <MenuItem key={item} value={item}>{item}</MenuItem>)}
                                </Select>
                              </FormControl>
                            </Col>
                          </Row> : null}
                          <Col xs={0} md={1}>

                          </Col>
                          <Row>
                            <Col xs={0} md={8}>
                            </Col>
                            <Col xs={12} md={4}>
                              <Box display='flex' alignItems="center" justifyContent="center" mt={3} style={{ float: "right" }}>
                                <Button startIcon={<CloseIcon />} sx={{ minWidth: 100 }} variant="outlined" onClick={(e) => goCancel(e)} >Cancel</Button>
                                <Button startIcon={<SearchIcon />} sx={{ minWidth: 100, ml: 1 }} variant="contained" onClick={(e) => getListOfStakeholder(e)} >Search</Button>
                              </Box>
                            </Col>
                            <div className='errorText_lle1'>{errorMessage.revenueError}</div>

                          </Row>
                          {mapped === true ? <div>
                            <div className="table-header-mappedtxt" style={{ marginTop: "1vh", marginBottom: "1vh" }}>Unmapped Stakeholders</div>
                            <Box sx={{
                              height: 500, width: '100%',
                              '& .MuiDataGrid-cell--editable': {
                                bgcolor: (theme) =>
                                  theme.palette.mode === 'dark' ? '#376331' : 'rgb(217 243 190)',
                              },
                            }}>
                              {
                                stakeholderList &&
                                <DataGrid style={{ marginLeft: "1vw" }}
                                  rows={stakeholderList}
                                  columns={unmappedStakeholderCol}
                                  pageSize={10}
                                  //getRowId={(row) => row.urn}
                                  components={{ Toolbar: QuickSearchToolbar }}
                                  checkboxSelection
                                  onSelectionModelChange={(newSelection) => {
                                    setSelectedStakeholders(newSelection.map(row => {
                                      let sno = ""

                                      stakeholderList.forEach(sch => {
                                        if (row == sch.id) {
                                          sno = sch.id;

                                        }
                                      })

                                      return sno;

                                    }));
                                  }}
                                />
                              }

                            </Box>
                            <div>
                              <Row className="row_mapping_screens">
                                <Col xs={12} md={5}>
                                  <FormControl fullWidth style={{ marginTop: "2vh" }}>
                                    <InputLabel>Scrutinizer</InputLabel>
                                    <Select label="Scrutinizer"
                                      onChange={(e) => onChangeStakeholderScrutinizer(e)}>
                                    <MenuItem disabled selected value> -- select an option -- </MenuItem>
                                    {scrutinizerList.map((item) => (
                                        <MenuItem value={item.id}>{item.firstname + ' ' + item.middlename + ' ' + item.lastname}</MenuItem>
                                      ))}

                                    </Select>
                                    <div className='errorText_lle1'>{errorMessage.addcommentsError}</div>
                                  </FormControl>
                                </Col>
                                <Col xs={12} md={5}>
                                  <FormControl fullWidth style={{ marginTop: "2vh" }}>
                                    <InputLabel>Lead Scrutinizer</InputLabel>
                                    <Select label="Lead Scrutinizer" onChange={(e) => handleLeadScrutinizerForStakeholder(e)}>
                                      <MenuItem disabled selected value=""> -- select an option -- </MenuItem>
                                      {leadScrutinizerList?.map((item) => (
                                        <MenuItem value={item.id}>{item.firstname + ' ' + item.middlename + ' ' + item.lastname}</MenuItem>
                                      ))}
                                    </Select>
                                    <div className='errorText_lle1'>{errorMessage.addcommentsError}</div>
                                  </FormControl>
                                </Col>
                                <Col xs={0} md={2}>
                                  <Box display='flex' alignItems="center" justifyContent="center" mt={3} style={{ float: "right" }}>
                                    <Button startIcon={<AddIcon />} sx={{ minWidth: 100 }} variant="contained" onClick={() => confirmStakeholderSubmission("Add")} >Add</Button>
                                  </Box>
                                </Col>
                              </Row>
                            </div> </div> : null}
                        </Row>
                      </div> :
                        <div>
                          <Row>
                            <Col xs={12} md={4}>
                              <div className="table-header-mappedtxt">Mapped Stakeholders</div>
                            </Col>
                            <Col xs={12} md={4}></Col>
                            <Col xs={12} md={4}>
                              <Button style={{ float: "right", marginBottom: "2vh" }} variant="contained" startIcon={<AddIcon />} onClick={(e) => addnewBtnClick(e)} >Add New Mapping</Button>
                            </Col>
                          </Row>
                          <Box sx={{
                            height: 500, width: '100%',
                            '& .MuiDataGrid-cell--editable': {
                              bgcolor: (theme) =>
                                theme.palette.mode === 'dark' ? '#376331' : 'rgb(217 243 190)',
                            },
                          }}>
                            {
                              allStakeholderScrutinizerMapping &&
                              <DataGrid style={{ marginLeft: "1vw" }}
                                rows={allStakeholderScrutinizerMapping}
                                columns={mappedStakeholderCol}
                                rowCount={rowCount}
                                rowsPerPageOptions={[10, 20]}
                                page={page}
                                pageSize={pageSize}
                                paginationMode="server"
                                onPageChange={(newPage) => { setPage(newPage); getStakeholderScrutinizerMapping(newPage, pageSize, searchText, false, sortField, sortOrder) }}
                                onPageSizeChange={(newPageSize) => { setPageSize(newPageSize); getStakeholderScrutinizerMapping(page, newPageSize, searchText, false, sortField, sortOrder) }}
                                sortingMode="server"
                                onSortModelChange={handleSortModelChange}
                                components={{ Toolbar: CustomDataGridToolbarServer }}
                                componentsProps={{ toolbar: { columns: mappedStakeholderCol, onSearch: fetchSearchData, onFetchData: fetchData, fileName: "StakeholderMapping.xlsx", dateFields: ['lastUpdatedDate'] } }}
                                checkboxSelection
                                isRowSelectable={(params) => params.row.status === "Scrutiny_Initiated"}
                                onSelectionModelChange={(newSelection) => {
                                  setSelectedStakeholders(newSelection.map(row => {
                                    let sno = ""
                                    allStakeholderScrutinizerMapping.forEach(sch => {
                                        if (row == sch.workflowMasterID) {
                                            sno = sch.stakeHolderMasterID;
                                      }
                                    })
                                    return sno;
                                  }));
                                }}
                                getRowId={(row) => row?.workflowMasterID}
                              />
                            }
                          </Box>
                          <Row className="row_mapping_screens">
                            <Col xs={12} md={5}>
                              <FormControl fullWidth style={{ marginTop: "2vh" }}>
                                <InputLabel>Scrutinizer</InputLabel>
                                <Select label="Scrutinizer"
                                  onChange={(e) => onChangeStakeholderScrutinizer(e)}>
                                  <MenuItem disabled selected value> -- select an option -- </MenuItem>
                                    {scrutinizerList?.map((item) => (
                                        <MenuItem value={item.id}>{item.firstname + ' ' + item.middlename + ' ' + item.lastname}</MenuItem>
                                    ))}

                                </Select>
                                <div className='errorText_lle1'>{errorMessage.addcommentsError}</div>
                              </FormControl>
                            </Col>
                            <Col xs={12} md={5}>
                              <FormControl fullWidth style={{ marginTop: "2vh" }}>
                                <InputLabel>Lead Scrutinizer</InputLabel>
                                <Select label="Lead Scrutinizer" onChange={(e) => handleLeadScrutinizerForStakeholder(e)}>
                                  <MenuItem disabled selected value=""> -- select an option -- </MenuItem>
                                  {leadScrutinizerList?.map((item) => (
                                    <MenuItem value={item.id}>{item.firstname + ' ' + item.middlename + ' ' + item.lastname}</MenuItem>
                                  ))}
                                </Select>
                                <div className='errorText_lle1'>{errorMessage.addcommentsError}</div>
                              </FormControl>
                            </Col>
                            <Col xs={0} md={2}>
                              <Box display='flex' alignItems="center" justifyContent="center" mt={3} style={{ float: "right" }}>
                                <Button startIcon={<UpdateIcon />} sx={{ minWidth: 100 }} variant="contained" onClick={() => confirmStakeholderSubmission("Update")} >Update</Button>
                              </Box>
                            </Col>
                          </Row>
                        </div>}
                    </div>
                  </TabPanel>
                  <TabPanel value="3" style={{ padding: "2vh 0vh 0vh 0vh" }}>
                    <div >
                      {mappingsupervisor === true ? <div>
                        <Row className="row_search">

                          {mappingsupervisor === true ? <div>
                            <div className="table-header-mappedtxt" style={{ marginTop: "1vh", marginBottom: "1vh" }}>Unmapped Scrutinizers</div>
                            <Box sx={{
                              height: 500, width: '100%',
                              '& .MuiDataGrid-cell--editable': {
                                bgcolor: (theme) =>
                                  theme.palette.mode === 'dark' ? '#376331' : 'rgb(217 243 190)',
                              },
                            }}>

                              {
                                allUnmappedScrutitoSupervisor &&
                                <DataGrid style={{ marginLeft: "1vw" }}
                                  rows={allUnmappedScrutitoSupervisor}
                                  columns={unmappedSupervisorCol}
                                  pageSize={10}

                                  components={{ Toolbar: QuickSearchToolbar }}
                                  checkboxSelection

                                  onSelectionModelChange={(newSelection) => {

                                    setSelectedRowsScrutiToSupervisor(newSelection.map(row => {
                                      let sno = ""

                                      allUnmappedScrutitoSupervisor.forEach(sch => {
                                        if (row == sch.id) {
                                          sno = sch.id;

                                        }
                                      })
                                      return sno;

                                    }));
                                  }}

                                />
                              }

                            </Box>
                            <div>
                              <Row>
                                <Col xs={12} md={4}>
                                  <FormControl fullWidth style={{ marginLeft: "2vh", marginTop: "2vh" }} error={errorMessage.supervisorError} helperText={errorMessage.supervisorError}>
                                    <InputLabel>Supervisor</InputLabel>
                                    <Select onChange={(e) => onChangeSupervisor(e)} label="Supervisor">
                                      <MenuItem disabled selected value> -- select an option -- </MenuItem>
                                      {supervisorList && supervisorList?.map((item) => (
                                        <MenuItem value={item.id}>{item.firstname + ' ' + item.middlename + ' ' + item.lastname}</MenuItem>
                                      ))}
                                    </Select>
                                  </FormControl>
                                </Col>
                                <Col xs={12} md={4}>
                                </Col>
                                <Col xs={0} md={4}>
                                  <Box display='flex' alignItems="center" justifyContent="center" mt={3} style={{ float: "right" }}>
                                    <Button startIcon={<CloseIcon />} sx={{ minWidth: 100 }} variant="outlined" onClick={(e) => goCancelSupervisor(e)} >Cancel</Button>
                                    <Button startIcon={<AddIcon />} sx={{ minWidth: 100, ml: 1 }} variant="contained" onClick={(e) => confirmSupervisorSubmission(e)} >Add</Button>
                                  </Box>
                                </Col>
                              </Row>

                            </div> </div> : null}
                        </Row>
                      </div> :
                        <div>
                          <Row>
                            <Col xs={12} md={4}>
                              <div className="table-header-mappedtxt">Mapped Scrutinizers</div>
                            </Col>
                            <Col xs={12} md={4}></Col>
                            <Col xs={12} md={4}>
                              <Button variant="contained" style={{ float: "right", marginBottom: "2vh" }} startIcon={<AddIcon />} onClick={(e) => addnewBtnClickSupervisor(e)} >Add New Mapping</Button>
                            </Col>
                          </Row>
                          <Box sx={{
                            height: 500, width: '100%',
                            '& .MuiDataGrid-cell--editable': {
                              bgcolor: (theme) =>
                                theme.palette.mode === 'dark' ? '#376331' : 'rgb(217 243 190)',
                            },
                          }}>
                            {
                              allmappedSupervisor &&
                              <DataGrid style={{ marginLeft: "1vw" }}
                                rows={allmappedSupervisor}
                                columns={mappedSupervisorCol}
                                pageSize={10}
                                getRowId={(row) => row?.scrutinizerID}
                                components={{ Toolbar: QuickSearchToolbar }}
                              />
                            }
                          </Box>
                          <div className="short-wait-div" >
                          </div>
                        </div>}
                    </div>
                  </TabPanel>
              
                </TabContext>
              </Col>
            </Row>
          </Container>
          <Dialog open={dialogOpen} onClose={() => setDialogOpen(false)} fullWidth maxWidth="sm">
            <DialogTitle>Update Districts for {editingDistRow?.userName}</DialogTitle>
            <DialogContent>
              <Autocomplete
                multiple
                disableCloseOnSelect
                options={districtOptions}
                value={selectedDistrictsForUpdate}
                onChange={(e, newValue) => {
                  // if (newValue.length === 0) {
                  //   toast.error("At least one district must be selected!")
                  //   return;
                  // }
                  setSelectedDistrictsForUpdate(newValue);
                }}
                renderInput={(params) => <TextField fullWidth {...params} label="Districts" variant="outlined" />}
              />
            </DialogContent>
            <DialogActions>
              <Button onClick={() => setDialogOpen(false)}>Cancel</Button>
              <Button
                onClick={() => onUpdateMappedDistricts()}
              >
                Update
              </Button>
            </DialogActions>
          </Dialog>
          <ConfirmationPopover onOpen={logModalOpen} onConfirm={onStakeholderScrutinizerRemove} action="Delete" onClose={handleConfirmLogModalClose} />
{/*          <ConfirmationPopover onOpen={logModalOpen3} onConfirm={onRemoveHandle} action="Delete" onClose={handleConfirmLogModalClose3} />*/}
          <ConfirmationPopover onOpen={logModalOpen4} onConfirm={onSupervisorScrutinizerRemove} action="Delete" onClose={handleConfirmLogModalClose4} />
{/*          <ConfirmationPopover onOpen={logModalOpenConfirm} onConfirm={onScrutinizerAdd} action="Submit" onClose={handleLogModalConfirmClose} />*/}
          <ConfirmationPopover onOpen={logModalOpenStakeholder} onConfirm={onStakeholderScrutinizerAdd} action="Submit" onClose={handleLogModalStakeholderClose} />
          <ConfirmationPopover onOpen={logModalOpenSupervisor} onConfirm={onScrutinizerSupervisorAdd} action="Submit" onClose={handleLogModalSupervisorClose} />
{/*          <ConfirmationPopover onOpen={logModalOpenUpdate} onConfirm={onConfirmMappingUpdate} action="Update" onClose={handleLogModalCloseUpdate} />*/}
          <ConfirmationPopover onOpen={logModalOpenLeadScruDstSave} onConfirm={onConfirmMappingLeadScruDstSave} action="Save" onClose={handleLogModalCloseLeadScruDst} />
          <ConfirmationPopover onOpen={logModalOpenLeadScruDstUpdate} onConfirm={onConfirmMappingLeadScruDstUpdate} action="Update" onClose={handleLogModalCloseLeadScruDstUpdate} />
          <ConfirmationPopover onOpen={logModalOpenLeadScruDstDelete} onConfirm={onConfirmMappingLeadScruDstDelete} action="Delete" onClose={handleLogModalCloseLeadScruDstDelete} />

        </CardContent>
      </Card>
    </div>
  );

}
export default ScrutinizerMapping;
